{
  "mark": "AI",
  "markLabel": "AI-assisted",
  "ask": "Ask the assistant",
  "drawer": {
    "documents": {
      "attach": "Attach photos or PDFs",
      "remove": "Remove {{name}}",
      "chosen": "Files to send",
      "sent": "Files sent",
      "read": "Read from them",
      "nothingRead": "Nothing could be read from them.",
      "readThem": "What are these documents?",
      "refused": {
        "type": "Only photos (JPG, PNG, WebP) and PDFs can be read.",
        "empty": "This file is empty.",
        "size": "Over {{limit}}, even made smaller. Photograph it page by page, or save a smaller PDF.",
        "count": "At most {{n}} files go with one question."
      }
    },
    "title": "Project assistant",
    "titleExplain": "Explain this alert",
    "disclaimer": "Uses this project’s data that you can see. Sent to OpenAI with your company’s key. Check figures before you rely on them. Nothing changes until you confirm.",
    "you": "You",
    "assistant": "Assistant",
    "conversation": "Conversation",
    "empty": "Ask about this project: why it is at risk, what can be billed, what changed this week.",
    "suggestions": "Suggestions",
    "suggest": {
      "risk": "Why is this project at risk?",
      "bill": "What can I bill this month?",
      "week": "What changed this week?"
    },
    "composer": "Your question",
    "placeholder": "Type a question…",
    "send": "Send",
    "stop": "Stop",
    "counter": "{{n}} / {{max}}",
    "tooLong": "Shorten your question to {{max}} characters.",
    "delete": "Delete conversation",
    "deleteTitle": "Delete this conversation?",
    "deleteBody": "Its questions and answers are removed now. Your administrator keeps a record of the runs, without the text.",
    "deleted": "Conversation deleted",
    "loading": "Opening the conversation…",
    "loadFailed": "The conversation couldn’t be opened.",
    "purged": "The text of earlier messages was removed under your company’s retention rule.",
    "working": "Working…",
    "stopped": "Stopped. Nothing was changed.",
    "retry": "Try again",
    "runsLeft_one": "{{n}} question left today",
    "runsLeft_other": "{{n}} questions left today",
    "paused_one": "Confirm or discard the proposal to continue.",
    "paused_other": "Confirm or discard each proposal to continue.",
    "cancelProposals": "Cancel the proposals",
    "cancelled": "Proposals cancelled. Nothing was changed.",
    "noneLeft": "No questions left today",
    "proposes": "The assistant proposes: {{list}}",
    "unanswered": "This question got no answer: it was stopped or didn’t finish. Ask again if you still need it.",
    "unansweredBy": {
      "cancelled": "This question got no answer: it was stopped. Ask again if you still need it.",
      "superseded": "This question got no answer: a new question was asked before its proposals were decided, so they were set aside.",
      "failed": "This question got no answer. {{reason}}",
      "expired": "This question got no answer: its proposals expired before they were decided. Ask again if you still need it.",
      "paused": "This question is waiting for a decision on its proposals.",
      "running": "This question is still being answered in another tab or window."
    },
    "earlier": "Earlier explanations"
  },
  "reading": {
    "kinds": {
      "INVOICE": "Invoice",
      "CREDIT_NOTE": "Credit note",
      "QUOTATION": "Quotation",
      "ORDER": "Order",
      "DELIVERY_NOTE": "Delivery note",
      "RECEIPT": "Receipt",
      "STATEMENT": "Statement",
      "PRICE_LIST": "Price list",
      "OTHER": "Document",
      "UNKNOWN": "Document"
    },
    "total": "total {{total}}",
    "lines": "lines: {{n}}"
  },
  "tools": {
    "read_documents": "the documents you sent",
    "propose_record_receipt": "recording a receipt",
    "propose_pay_supplier": "paying a supplier",
    "propose_post_purchase": "posting a purchase",
    "propose_void_purchase": "voiding a purchase",
    "propose_post_credit_note": "posting a credit note",
    "propose_void_credit_note": "voiding a credit note",
    "propose_archive_customer": "archiving a customer",
    "propose_archive_supplier": "archiving a supplier",
    "propose_archive_product": "archiving a product",
    "propose_post_invoice": "posting an invoice",
    "propose_void_invoice": "voiding an invoice",
    "propose_create_supplier": "a new supplier",
    "propose_update_supplier": "a change to a supplier",
    "propose_update_prices": "a price change",
    "propose_adjust_stock": "a stock adjustment",
    "propose_draft_invoice": "a draft invoice",
    "propose_draft_quotation": "a quotation",
    "propose_draft_purchase_bill": "a draft purchase bill",
    "propose_create_customer": "a new customer",
    "propose_update_customer": "a change to a customer",
    "get_project_overview": "the project overview",
    "get_project_financials": "financials",
    "list_project_signals": "alerts",
    "list_milestones": "milestones",
    "list_project_tasks": "tasks",
    "get_billing_status": "billing",
    "list_cost_documents": "cost documents",
    "get_time_summary": "time logged",
    "get_weekly_changes": "this week’s changes",
    "get_contract_status": "the contract",
    "get_trial_balance": "the trial balance",
    "get_profit_and_loss": "profit and loss",
    "get_balance_sheet": "the balance sheet",
    "get_cash_flow": "cash flow",
    "get_vat_return": "the VAT return",
    "find_accounts": "accounts",
    "get_account_movements": "account movements",
    "get_receivables_aging": "receivables aging",
    "get_payables_aging": "payables aging",
    "list_expenses": "expenses",
    "get_bank_status": "bank reconciliation status",
    "get_books_health": "Books health",
    "get_drilldown": "the figure’s movements",
    "get_account_roles": "account mapping",
    "list_expense_categories": "expense categories",
    "get_bank_statement_lines": "the statement’s lines",
    "get_payee_history": "the payee’s earlier expenses",
    "get_stock_overview": "the stock overview",
    "find_stock_items": "products in stock",
    "get_item_stock": "the product’s stock",
    "list_stock_movements": "stock movements",
    "get_stock_checks": "the stock checks",
    "get_reorder_suggestions": "reorder suggestions",
    "get_stock_valuation": "the stock valuation",
    "get_stock_adjustments": "stock adjustments",
    "list_stock_transfers": "stock transfers",
    "list_warehouses": "warehouses",
    "propose_stock_task": "a follow-up task",
    "propose_stock_transfer": "a draft transfer",
    "propose_draft_purchase": "a draft purchase",
    "propose_reorder_level": "a reorder level",
    "find_suppliers": "suppliers",
    "list_supplier_items": "what this supplier sold you before",
    "find_purchase_items": "your products",
    "find_service_sites": "service sites",
    "get_service_site": "the site",
    "get_site_places": "the site’s places",
    "list_place_assets": "the place’s equipment",
    "list_asset_types": "asset types",
    "list_site_templates": "site templates",
    "find_service_customers": "customers",
    "propose_service_site": "a new site",
    "propose_generate_places": "places to add",
    "propose_duplicate_place": "a place to duplicate",
    "propose_place_assets": "equipment to add",
    "find_service_contracts": "maintenance contracts",
    "get_service_contract": "the contract",
    "get_asset_checks": "the asset’s checks",
    "find_records": "the records",
    "get_record": "the record",
    "run_report": "the report"
  },
  "chip": {
    "running": "Reading {{what}}…",
    "done": "Read {{what}}",
    "failed": "Couldn’t read {{what}}",
    "unknown": "project data",
    "records_one": "{{n}} record",
    "records_other": "{{n}} records",
    "none": "No records to list.",
    "read": "Read: {{list}}"
  },
  "proposals": {
    "propose_record_receipt": {
      "title": "Record a receipt of {{amount}} from {{customer}}",
      "fields": {
        "receiptDate": "Receipt date",
        "reference": "Reference"
      },
      "note": "Paid by {{method}} into {{account}} on {{date}}. {{allocated}} settles the invoices below; the rest ({{credit}}) stays as the customer’s credit. If a balance changes before you confirm, the card is refused.",
      "open": "Open the receipt"
    },
    "propose_pay_supplier": {
      "title": "Pay {{supplier}} {{amount}}",
      "fields": {
        "paymentDate": "Payment date",
        "reference": "Reference"
      },
      "note": "Paid by {{method}} from {{account}} on {{date}}. {{allocated}} settles the purchases below; the rest ({{advance}}) stays as an advance to the supplier. If a balance changes before you confirm, the card is refused.",
      "open": "Open the payment"
    },
    "propose_post_purchase": {
      "title": "Post the draft purchase from {{supplier}}",
      "note": "Posting numbers the purchase ({{total}}, dated {{date}}), records what you owe the supplier and receives its stocked lines ({{goods}} of {{count}}) into warehouse {{warehouse}}. Once posted it can’t be edited, only voided.",
      "open": "Open the purchase"
    },
    "propose_void_purchase": {
      "title": "Void purchase {{number}} from {{supplier}}",
      "fields": {
        "reason": "Reason"
      },
      "note": "Voiding reverses it in the books and the supplier’s account and takes its goods back out of stock. Total {{total}}, paid {{paid}}. If it is paid or changed before you confirm, the card is refused.",
      "open": "Open the purchase"
    },
    "propose_post_credit_note": {
      "title": "Post the draft credit note for {{customer}}",
      "note": "Posting numbers the credit note ({{total}}, dated {{date}}; credited invoice {{invoice}}) and records it in the books and the customer’s account. Once posted it can’t be edited, only voided.",
      "open": "Open the credit note"
    },
    "propose_void_credit_note": {
      "title": "Void credit note {{number}} for {{customer}}",
      "fields": {
        "reason": "Reason"
      },
      "note": "Voiding reverses it in the books and the customer’s account. Total {{total}}, allocated {{allocated}}, refunded {{refunded}}. If it is used or changed before you confirm, the card is refused.",
      "open": "Open the credit note"
    },
    "propose_archive_customer": {
      "title": "Archive the customer {{name}}",
      "note": "Code {{code}}. Archiving takes the customer out of lists and new documents. Nothing is deleted: its documents and history stay, and you can restore it from its page.",
      "open": "Open the customer"
    },
    "propose_archive_supplier": {
      "title": "Archive the supplier {{name}}",
      "note": "Code {{code}}. Archiving takes the supplier out of lists and new documents. Nothing is deleted, and you can restore it from its page. A supplier you still owe money to can’t be archived.",
      "open": "Open the supplier"
    },
    "propose_archive_product": {
      "title": "Archive the product {{name}}",
      "note": "SKU {{code}}. Archiving takes the product out of lists and new documents. Nothing is deleted, and you can restore it from its page. A product with stock on hand can’t be archived.",
      "open": "Open the product"
    },
    "sensitive": "Sensitive change",
    "sensitiveHint": "It posts, voids, moves money or archives. Read the card before you confirm.",
    "propose_post_invoice": {
      "title": "Post the draft invoice for {{customer}}",
      "note": "Posting numbers the invoice ({{count}} lines, {{total}}) and records it in the books and the customer’s account. It is corrected afterwards only by a credit note or a void.",
      "open": "Open the invoice"
    },
    "propose_void_invoice": {
      "title": "Void invoice {{number}} for {{customer}}",
      "fields": {
        "reason": "Reason"
      },
      "note": "Voiding reverses it in the books and the customer’s account. Total {{total}}, paid {{paid}}. If it is paid or changed before you confirm, the card is refused.",
      "open": "Open the invoice"
    },
    "changes": {
      "caption": "What the card changes",
      "before": "Now",
      "after": "After",
      "all": "Show all {{n}}",
      "fewer": "Show fewer"
    },
    "propose_create_supplier": {
      "title": "Add the supplier {{name}}",
      "fields": {
        "name": "Name",
        "nameAr": "Name in Arabic",
        "company": "Company",
        "contactPerson": "Contact person",
        "mobile": "Mobile",
        "email": "E-mail",
        "city": "City"
      },
      "open": "Open the supplier"
    },
    "propose_update_supplier": {
      "title": "Change the supplier {{code}} {{name}}",
      "fields": {
        "name": "Name",
        "nameAr": "Name in Arabic",
        "company": "Company",
        "contactPerson": "Contact person",
        "mobile": "Mobile",
        "email": "E-mail",
        "city": "City",
        "status": "Status"
      },
      "statuses": {
        "ACTIVE": "Active",
        "INACTIVE": "Inactive"
      },
      "note": "Only the fields shown change. If someone changes this supplier before you confirm, the card is refused.",
      "open": "Open the supplier"
    },
    "propose_update_prices": {
      "title_one": "Change the price of {{name}}",
      "title_other": "Change {{count}} prices",
      "note": "If any price is no longer the one shown when you confirm, nothing changes and the card is refused.",
      "open": "Open the product"
    },
    "propose_adjust_stock": {
      "title": "Adjust the stock in {{warehouse}}",
      "titleCount": "Record a stock count in {{warehouse}}",
      "fields": {
        "reason": "Reason",
        "notes": "Notes"
      },
      "reasons": {
        "DAMAGE": "Damaged",
        "EXPIRED": "Expired",
        "THEFT_LOSS": "Theft or loss",
        "FOUND": "Found",
        "CORRECTION": "Correction",
        "OTHER": "Other"
      },
      "note": "Stock added is valued at the item’s average cost. If the stock moves before you confirm, the card is refused.",
      "open": "Open the adjustment"
    },
    "propose_draft_invoice": {
      "title": "Draft invoice for {{customer}}",
      "fields": {
        "invoiceDate": "Invoice date",
        "reference": "Reference"
      },
      "note": "A draft: nothing is posted, no stock moves. You post it from its page.",
      "open": "Open the draft"
    },
    "propose_draft_quotation": {
      "title": "Quotation for {{customer}}",
      "fields": {
        "quotationDate": "Quotation date",
        "reference": "Reference"
      },
      "note": "A quotation has no effect on the books or the stock until it becomes an invoice.",
      "open": "Open the quotation"
    },
    "propose_draft_purchase_bill": {
      "title": "Draft purchase bill from {{supplier}}",
      "fields": {
        "purchaseDate": "Bill date",
        "supplierReference": "Supplier’s bill number"
      },
      "note": "A draft: nothing is received or posted. You post it from its page.",
      "open": "Open the draft"
    },
    "propose_create_customer": {
      "title": "Add the customer {{name}}",
      "fields": {
        "name": "Name",
        "nameAr": "Name in Arabic",
        "company": "Company",
        "mobile": "Mobile",
        "email": "E-mail",
        "city": "City"
      },
      "open": "Open the customer"
    },
    "propose_update_customer": {
      "title": "Change the customer {{code}} {{name}}",
      "fields": {
        "name": "Name",
        "nameAr": "Name in Arabic",
        "company": "Company",
        "mobile": "Mobile",
        "email": "E-mail",
        "city": "City",
        "status": "Status"
      },
      "statuses": {
        "ACTIVE": "Active",
        "INACTIVE": "Inactive"
      },
      "note": "Only the fields shown change. If someone changes this customer before you confirm, the card is refused.",
      "open": "Open the customer"
    },
    "label": "Proposal",
    "status": {
      "PENDING": "Awaiting you",
      "APPROVED": "Confirmed",
      "EXECUTED": "Done",
      "REJECTED": "Discarded",
      "EXPIRED": "Expired",
      "FAILED": "Failed"
    },
    "edit": "Edit",
    "doneEditing": "Done editing",
    "confirm": "Confirm",
    "discard": "Discard",
    "discardReason": "Tell the assistant why (optional)",
    "discardConfirm": "Discard proposal",
    "undo": "Undo",
    "edited": "Edited by you",
    "expires": "Decide by {{time}}",
    "waitingConfirm": "Confirmed. Decide the other proposals to continue.",
    "waitingDiscard": "Discarded. Decide the other proposals to continue.",
    "running": "Running it…",
    "confirmedBody": "Confirmed. The assistant ran it with your account.",
    "openResult": "Open {{label}}",
    "discardedBody": "Nothing was changed.",
    "expiredBody": "This proposal expired before it was confirmed. Ask again for a new one.",
    "failedBody": "It wasn’t done. {{reason}}",
    "failure": {
      "VALIDATION_FAILED": "Its values no longer pass the checks for this action. Ask the assistant again, or do it yourself.",
      "UNKNOWN_TOOL": "The assistant can no longer do this. Ask again, or do it yourself.",
      "NOT_FOUND": "The record it was about is no longer there, or you can no longer see it."
    },
    "required": "Fill in {{field}}.",
    "fallbackTitle": "A change the assistant proposes",
    "empty": "—",
    "propose_create_task": {
      "title": "Create task “{{title}}”",
      "fields": {
        "title": "Task",
        "description": "Details",
        "dueDate": "Due",
        "priority": "Priority"
      },
      "priority": {
        "LOW": "Low",
        "NORMAL": "Normal",
        "HIGH": "High",
        "URGENT": "Urgent"
      }
    },
    "propose_milestone_forecast": {
      "title": "Move milestone {{milestone}} to {{date}}",
      "fields": {
        "plannedFinish": "New date"
      },
      "note": "The milestone keeps its name; only its planned date moves."
    },
    "propose_acknowledge_signal": {
      "title": "Acknowledge the alert “{{signal}}”",
      "fields": {
        "note": "Why",
        "untilOn": "Silenced until"
      },
      "note": "Its notifications stop until that date; it still counts in the project’s health."
    },
    "reason": "Your reason: {{reason}}",
    "propose_books_task": {
      "title": "Create task “{{title}}”",
      "fields": {
        "title": "Task",
        "description": "Details",
        "dueDate": "Due",
        "priority": "Priority"
      },
      "priority": {
        "LOW": "Low",
        "NORMAL": "Normal",
        "HIGH": "High",
        "URGENT": "Urgent"
      }
    },
    "propose_create_expense_category": {
      "title": "Create expense category “{{name}}”, posting to {{account}}",
      "fields": {
        "name": "Name",
        "nameAr": "Name in Arabic"
      }
    },
    "propose_create_account": {
      "title": "Create account {{code}} “{{name}}”",
      "fields": {
        "code": "Code",
        "name": "Name",
        "nameAr": "Name in Arabic"
      },
      "note": "Type: {{type}}. Under: {{parent}}."
    },
    "propose_map_account_role": {
      "title": "Map “{{role}}” to {{account}}",
      "note": "Mapped now to: {{current}}. Future postings for this role go to the new account; balances already posted stay where they are."
    },
    "propose_bank_match": {
      "title": "Match line {{lineNo}} of {{statement}} ({{txnDate}}, {{amount}}) to entry {{entry}} of {{entryDate}}",
      "line": "Statement line",
      "entry": "Book entry",
      "reason": "Why"
    },
    "propose_bank_adjustment": {
      "title": "Post a bank adjustment of {{amount}} to {{account}}",
      "fields": {
        "description": "Description"
      },
      "postsJournal": "Confirming posts a journal entry in the books on the line’s date ({{txnDate}}), between the bank account and this account, and matches line {{lineNo}} of {{statement}} to it. It can be undone only by reversing the entry.",
      "confirm": "Confirm and post"
    },
    "propose_dismiss_finding": {
      "title": "Mark “{{code}}” as not a problem",
      "fields": {
        "reason": "Why it is not a problem",
        "untilOn": "Until"
      },
      "howLong": "For how long",
      "note": "It stays listed on Books health, muted, with your name and reason.",
      "titleFinding": "Mark “{{title}}” as not a problem",
      "until": "Until {{date}}",
      "forGood": "For this item (for good)",
      "editNote": "Leave “Until” empty to dismiss it for good on this item."
    },
    "lines": {
      "caption": "The lines of the draft",
      "item": "Product",
      "quantity": "Quantity",
      "unitPrice": "Unit price",
      "amount": "Amount",
      "total": "Estimated total",
      "count_one": "{{n}} line",
      "count_other": "{{n}} lines",
      "all": "Show all {{n}} lines",
      "fewer": "Show fewer",
      "scroll": "The lines of the draft; scroll sideways to see every column"
    },
    "propose_stock_task": {
      "title": "Create task “{{title}}”",
      "fields": {
        "title": "Task",
        "description": "Details",
        "dueDate": "Due",
        "priority": "Priority"
      },
      "priority": {
        "LOW": "Low",
        "NORMAL": "Normal",
        "HIGH": "High",
        "URGENT": "Urgent"
      },
      "open": "Open the task"
    },
    "propose_stock_transfer": {
      "title": "Create a draft transfer from {{from}} to {{to}}",
      "fields": {
        "transferDate": "Transfer date",
        "notes": "Notes"
      },
      "draftNote": "Confirming creates a draft transfer with these lines. Nothing moves until you post it; you can change it on its page first.",
      "confirm": "Create draft",
      "done": "Draft created. Nothing is moved until you post it.",
      "open": "Open the draft transfer",
      "left_one": "{{n}} more product is left for another draft.",
      "left_other": "{{n}} more products are left for another draft."
    },
    "propose_draft_purchase": {
      "title": "Create a draft purchase from {{supplier}}",
      "fields": {
        "purchaseDate": "Purchase date",
        "notes": "Notes"
      },
      "warehouse": "Receive into",
      "draftNote": "Confirming creates a draft purchase with these lines. Nothing is ordered or received until you post it; you can change it on its page first.",
      "confirm": "Create draft",
      "done": "Draft created. Nothing is ordered or received until you post it.",
      "open": "Open the draft purchase",
      "left_one": "{{n}} more product is left for another draft.",
      "left_other": "{{n}} more products are left for another draft."
    },
    "propose_reorder_level": {
      "title": "Set the reorder level of {{item}}",
      "fields": {
        "reorderLevel": "New reorder level"
      },
      "note": "Reorder level now: {{current}}. The new level applies to the product in every warehouse.",
      "done": "Was {{current}}.",
      "open": "Open the product’s movements"
    },
    "propose_service_site": {
      "title": "New site “{{name}}” for {{customer}}",
      "fields": {
        "name": "Site name",
        "address": "Address",
        "code": "Code"
      },
      "note": "Confirming adds the site to the customer. Its places and equipment come next, on its page or here.",
      "open": "Open the site"
    },
    "propose_generate_places": {
      "title": "Add places to {{site}}",
      "note": "Under: {{under}}. New places: {{create}}. Already there, kept as they are: {{existing}}. First: {{first}}.",
      "noPlace": "the top of the site",
      "open": "Open the site"
    },
    "propose_duplicate_place": {
      "title": "Duplicate {{place}} in {{site}}",
      "note": "Copies: {{copies}}. New places: {{create}}. Already there, kept as they are: {{existing}}. Equipment copied: {{assets}}. First: {{first}}.",
      "open": "Open the site"
    },
    "propose_place_assets": {
      "title": "Add {{count}} × {{type}} at {{place}}",
      "fields": {
        "count": "How many",
        "position": "Position",
        "brand": "Brand",
        "model": "Model"
      },
      "note": "Site: {{site}}. Each one gets its own tag.",
      "noPlace": "the site itself",
      "open": "Open the site"
    }
  },
  "errors": {
    "AI_DISABLED": "Your Sahab provider has the assistant switched off. Ask them if you want to use it.",
    "AI_BLOCKED_BY_POLICY": "The assistant can’t run for your company now. Your administrator can check Settings › AI assistant.",
    "AI_KEY_MISSING": "Your administrator needs to add the company’s OpenAI key in Settings › AI assistant.",
    "AI_ACK_REQUIRED": "An administrator needs to accept the assistant’s terms in Settings › AI assistant first.",
    "AI_LIMIT_ABOVE_CAP": "The company’s monthly limit is above what your Sahab provider allows. Your administrator can lower it.",
    "AI_MODEL_NOT_ALLOWED": "The chosen model isn’t allowed. Your administrator can pick another in Settings › AI assistant.",
    "AI_BUDGET_EXCEEDED": "The company’s assistant budget for this month is used up. An administrator can raise it in Settings › AI assistant.",
    "AI_BUDGET_EXCEEDED_user_daily": "You’ve used today’s questions.",
    "AI_RUN_IN_PROGRESS": "You already have a question running. Wait for it to finish, or stop it, then ask again.",
    "AI_RUN_EXPIRED": "These proposals expired. Ask again to get new ones.",
    "AI_RESUME_INCOMPATIBLE": "The assistant was updated since these proposals were made. Ask again to get new ones.",
    "AI_NOT_ALLOWED": "This account can’t use the assistant. Sign in with your own account.",
    "AI_PROVIDER_AUTH": "OpenAI refused the company’s key. Your administrator needs to check the key in Settings › AI assistant.",
    "AI_PROVIDER_UNAVAILABLE": "OpenAI can’t be reached right now. Try again in a few minutes.",
    "AI_PROVIDER_RATE_LIMITED": "OpenAI is limiting requests from your company’s key. Try again in a minute.",
    "AI_TURN_LIMIT": "The question needed too many steps. Ask something narrower.",
    "AI_MODEL_ERROR": "The assistant’s answer couldn’t be used. Try again, or rephrase the question.",
    "AI_TIMEOUT": "The assistant took too long to answer. Try again, or ask something narrower.",
    "PLAN_TOO_LARGE": "A plan can add at most 20 phases and 200 tasks at once. Remove some, or apply it in two parts.",
    "FORBIDDEN": "You no longer have permission to do this. Ask your administrator if you need it.",
    "RATE_LIMITED": "You’ve asked several questions in a short time. Wait a moment, then try again.",
    "RATE_LIMITED_wait_one": "You’ve asked several questions in a short time. Try again in {{n}} second.",
    "RATE_LIMITED_wait_other": "You’ve asked several questions in a short time. Try again in {{n}} seconds.",
    "STREAM_ENDED": "The answer was cut off. Try again.",
    "AI_ATTACHMENTS_NOT_ACCEPTED": "This part of the assistant doesn’t read documents. Type the question instead.",
    "AI_TOO_MANY_ATTACHMENTS": "Too many documents at once. Remove some, then try again.",
    "unknown": "The assistant couldn’t do this. Try again; if it happens again, tell your administrator.",
    "AI_DOCUMENT_TOO_LONG": "A PDF has more pages than the assistant reads at once. Send it in parts.",
    "AI_DOCUMENT_UNREADABLE": "A PDF couldn’t be read: it may be damaged or password-protected, or too much to read at once. Send photos of its pages instead.",
    "AI_BUSY": "The assistant is reading other documents. Try again in a minute."
  },
  "unavailable": {
    "disabled": "Your Sahab provider has the assistant switched off. Ask them if you want to use it.",
    "module_off": "The AI assistant isn’t part of your company’s subscription. Your Sahab provider can add it.",
    "no_policy": "Your Sahab provider hasn’t set up the assistant for your company yet.",
    "suspended": "Your Sahab provider has paused the assistant for your company.",
    "not_enabled": "The assistant isn’t turned on. An administrator can turn it on in Settings › AI assistant.",
    "no_key": "Your administrator needs to add the company’s OpenAI key in Settings › AI assistant.",
    "residency": "Your company keeps its data in Oman. An administrator must approve sending it to OpenAI in Settings › AI assistant.",
    "not_allowed": "Your account doesn’t have access to the assistant. Ask your administrator.",
    "feature_off": "This part of the assistant is turned off. An administrator can turn it on in Settings › AI assistant.",
    "area_off": "This part of the assistant isn’t included for your company. Your Sahab provider can add it."
  },
  "unverified": "Unverified figure",
  "unverifiedList": "Check these figures; no project data returned them:",
  "explain": {
    "action": "Explain “{{title}}” with the assistant",
    "thisAlert": "this alert",
    "ruleBased": "From the alert’s own rule, without the assistant",
    "rule": "{{dimension}}: {{body}}",
    "thresholds": "The thresholds are your company’s insight settings."
  },
  "run": {
    "working": "The assistant is working…",
    "stop": "Stop",
    "stopped": "Stopped.",
    "retry": "Try again",
    "unreadable": "The assistant’s answer couldn’t be read. Try again."
  },
  "statusDraft": {
    "action": "Draft with the assistant",
    "title": "Draft with the assistant",
    "description": "The assistant drafts the four sections from this project’s data for {{week}}. The key figures still come from the week’s record.",
    "prompt": "Draft the weekly status report for the week starting {{weekStart}}.",
    "use": "Use this draft",
    "create": "Create report from this draft",
    "replaceTitle": "Replace the text you wrote?",
    "replaceBody": "The four sections are replaced by the assistant’s draft. Nothing is saved until you save the report.",
    "replaceConfirm": "Replace text",
    "filled": "Draft filled in. Check the figures before saving.",
    "note": "Drafted with the assistant. Check the figures before saving."
  },
  "plan": {
    "action": "Break a scope into phases",
    "title": "Break a scope into phases",
    "description": "Describe the work. The assistant proposes phases, milestones and tasks; you edit them before anything is added to the plan.",
    "scope": "Scope of work",
    "scopeHint": "Paste the scope or describe it in your words. At most {{max}} characters.",
    "propose": "Propose phases",
    "again": "Start again",
    "anchor": "Dates count working days from {{date}}, on the company calendar.",
    "counts": "Phases: {{phases}} · Milestones: {{milestones}} · Tasks: {{tasks}}",
    "phase": "Phase {{n}}",
    "phaseName": "Phase name",
    "phaseNameAr": "Arabic name",
    "offset": "Starts after (working days)",
    "duration": "Duration (working days)",
    "weight": "Weight %",
    "dates": "{{start}} – {{end}}",
    "milestones": "Milestones",
    "milestoneName": "Milestone",
    "milestoneOffset": "Due after (working days)",
    "tasks": "Tasks",
    "taskTitle": "Task",
    "taskOffset": "Due after (working days)",
    "noDue": "No due date",
    "addPhase": "Add phase",
    "addMilestone": "Add milestone",
    "addTask": "Add task",
    "remove": "Remove {{name}}",
    "unnamed": "this row",
    "assumptions": "The assistant assumed",
    "apply": "Add to the plan",
    "tooMany": "At most {{phases}} phases and {{tasks}} tasks can be added at once.",
    "nameRequired": "Every phase, milestone and task needs a name.",
    "empty": "The assistant proposed no phases. Add more detail to the scope and try again.",
    "applied_one": "1 phase added to the plan",
    "applied_other": "{{n}} phases added to the plan",
    "start": "Start the new phases on",
    "after_one": "Added after the plan’s existing phase.",
    "after_other": "Added after the plan’s existing {{n}} phases.",
    "tooLong": "That text is longer than {{max}} characters, so it wasn’t pasted. Shorten it, then paste again.",
    "againTitle": "Start again?",
    "againBody": "Your changes to the proposed phases are discarded and you describe the scope again."
  },
  "boq": {
    "mappingTitle": "Match the file’s columns",
    "mappingBody": "This file’s headings aren’t the import’s own. Say which column holds what; it is imported with those columns.",
    "suggest": "Suggest column mapping",
    "suggestHint": "Only the heading row and the first 5 rows are sent to the assistant.",
    "column": "Column in the file",
    "sample": "First value",
    "field": "Imports as",
    "confidence": "Confidence",
    "notImported": "Not imported",
    "suggested": "Suggested by the assistant. Check each column, then confirm.",
    "confirm": "Use this mapping",
    "missing": "Map the {{fields}} columns first.",
    "duplicate": "“{{field}}” is chosen for more than one column.",
    "checkTitle": "Quantity × rate check",
    "checkOk": "Every row’s amount is its quantity × rate.",
    "checkSkipped": "Map quantity, rate and amount to check the rows’ amounts.",
    "mismatches_one": "{{n}} row’s amount isn’t its quantity × rate:",
    "mismatches_other": "{{n}} rows’ amounts aren’t their quantity × rate:",
    "mismatch": "Row {{row}}: {{qty}} × {{rate}} = {{expected}}, the file says {{amount}}",
    "more": "and {{n}} more",
    "continue": "Preview the import",
    "back": "Change the mapping",
    "lowConfidence": "Check this",
    "fields": {
      "section_path": "Section",
      "item_no": "Item no.",
      "description": "Description",
      "description_ar": "Arabic description",
      "unit": "Unit",
      "quantity": "Quantity",
      "rate": "Rate",
      "amount": "Amount",
      "kind": "Kind",
      "measure_by": "Measured by",
      "wbs_code": "Plan node",
      "cost_category": "Cost category",
      "cost_rate": "Cost rate"
    }
  },
  "assisted": "AI-assisted",
  "table": {
    "copy": "Copy as CSV",
    "copied": "Table copied as CSV",
    "copyFailed": "The table couldn’t be copied. Select it and copy it yourself."
  },
  "books": {
    "title": {
      "ask": "Accounting assistant",
      "explain": "Explain a figure",
      "review": "Review the books",
      "coding": "Bank line suggestions",
      "setup": "Setup suggestions"
    },
    "disclaimer": "Uses the books you are allowed to see. Sent to OpenAI with your company’s key. Check figures before you rely on them. Nothing changes until you confirm.",
    "disclaimerStatement": "Uses this statement and the books you are allowed to see. Sent to OpenAI with your company’s key. Nothing is matched or posted until you confirm.",
    "empty": {
      "ask": "Ask about the books: why profit moved, who owes the most, what a report shows. Ask for a table when you want one.",
      "explain": "Choose ✦ on a report line to see what is behind the figure.",
      "review": "The assistant explains this month’s Books health findings and says what to fix first.",
      "coding": "The assistant suggests matches and adjustments for the lines not matched yet.",
      "setup": "The assistant suggests expense categories, missing accounts and account mappings. Each comes as a card you confirm or discard."
    },
    "suggest": {
      "profit": "Why is profit lower than last month?",
      "owes": "Who owes us the most?",
      "trialBalance": "Show this month’s trial balance as a table",
      "unmatched": "Suggest matches for the unmatched lines",
      "categories": "Suggest expense categories for this company",
      "accounts": "Which accounts are we missing?",
      "mapping": "Suggest accounts for the roles not mapped yet"
    },
    "thisFinding": "this finding",
    "explain": {
      "action": "Explain {{name}}",
      "label": "What is behind this figure",
      "loading": "Loading the figure’s movements…",
      "asOf": "As of {{date}}",
      "total": "Total",
      "compared": "Compared period",
      "comparedWith": "Compared with {{period}}",
      "change": "Change",
      "movements": "Biggest movements",
      "source": "Document",
      "amount": "Amount",
      "compareAmount": "Compared",
      "noSource": "A record you can’t open",
      "other": "All other movements",
      "noMovements": "Nothing moved this figure in the period.",
      "accounts": "Accounts in this line",
      "ask": "Ask the assistant to explain",
      "askHint": "The figures above come from the books, without the assistant. The assistant adds words, and nothing changes until you confirm.",
      "asked": "Asked below. The figures above come from the books, without the assistant.",
      "types": {
        "sales_invoice": "Sales invoice",
        "receipt": "Receipt",
        "credit_note": "Credit note",
        "customer_refund": "Customer refund",
        "purchase": "Purchase",
        "supplier_payment": "Supplier payment",
        "supplier_return": "Supplier return",
        "supplier_refund": "Supplier refund",
        "expense": "Expense",
        "treasury_transfer": "Cash or bank transfer",
        "treasury_account": "Opening balance of a cash or bank account",
        "bank_statement": "Bank reconciliation",
        "stock_adjustment": "Stock adjustment",
        "stock_transfer": "Stock transfer",
        "pos_sale": "Till sale",
        "pos_return": "Till return",
        "pos_shift": "Till shift (cash over or short)",
        "project_material_issue": "Material issue",
        "project_cost_entry": "Project cost",
        "journal_entry": "Journal entry"
      },
      "actionMovement": "Explain the movement on {{account}}",
      "customer": "Customer"
    },
    "review": {
      "action": "Review with the assistant",
      "prompt": "Review the books from {{from}} to {{to}}: what should I fix first?"
    },
    "setup": {
      "action": "Suggest…",
      "prompt": {
        "categories": "Suggest expense categories for this company, with the account each posts to.",
        "accounts": "Which accounts is our chart missing for the way we work? Suggest them.",
        "mapping": "Suggest accounts for the account roles that aren’t mapped yet."
      }
    },
    "coding": {
      "bankAction": "Suggest for unmatched lines",
      "bankPrompt": "Suggest matches or adjustments for the unmatched lines of this statement."
    },
    "commentary": {
      "action": "Draft commentary",
      "title": "Management commentary",
      "description": "A draft for {{period}}, from the books. Read it and check the figures before you share it.",
      "prompt": "Draft the management commentary for {{period}}.",
      "sections": {
        "summary": "Summary",
        "revenue": "Revenue",
        "costs": "Costs",
        "cash": "Cash",
        "watch": "Points to watch"
      },
      "check": "Figures marked “Unverified” didn’t come from the books: check them before you share the commentary.",
      "copy": "Copy",
      "copied": "Commentary copied",
      "copyFailed": "The commentary couldn’t be copied. Select the text and copy it yourself.",
      "printNote": "Drafted with the AI assistant; check figures before relying on them.",
      "unverifiedList": "Check these figures; no report from your books returned them:"
    }
  },
  "stock": {
    "menu": "Assistant",
    "title": {
      "ask": "Inventory assistant",
      "explain": "Explain a product",
      "review": "Review the stock",
      "reorder": "Reorder suggestions"
    },
    "disclaimer": "Uses the stock records you are allowed to see. Sent to OpenAI with your company’s key. Check figures before you rely on them. Nothing changes until you confirm.",
    "empty": {
      "ask": "Ask about the stock: what is running out, where a product is, what was written off. Ask for a table when you want one.",
      "explain": "Choose ✦ on a product to see what moved its quantity and its cost.",
      "review": "The assistant reads the stock checks and says what to fix first.",
      "reorder": "The assistant says what to reorder, how much and from which supplier, and can prepare a draft purchase or a draft transfer for you to confirm."
    },
    "suggest": {
      "runningOut": "What is running out?",
      "where": "Which warehouse holds the most stock?",
      "writeOffs": "What did we write off this month?",
      "whyQuantity": "Why is the quantity what it is?",
      "whyCost": "What changed its average cost?",
      "whenOut": "When will it run out?",
      "fixFirst": "What should I fix first?",
      "belowZero": "Which products are below zero, and why?",
      "slow": "What is held but not selling?",
      "orderWeek": "What should I order this week?",
      "bySupplier": "Show the reorder list by supplier",
      "transfer": "What can another warehouse send instead?"
    },
    "review": {
      "action": "Review stock",
      "prompt": "Review the stock: what should I fix first?",
      "promptIn": "Review the stock in {{warehouse}}: what should I fix first?"
    },
    "reorder": {
      "action": "Suggest a reorder",
      "prompt": "What should I reorder, how much and from which supplier?",
      "promptIn": "What should I reorder for {{warehouse}}, how much and from which supplier?"
    },
    "insight": {
      "action": "Stock insight: {{name}}",
      "title": "Stock insight"
    },
    "explain": {
      "action": "Explain {{name}}",
      "label": "What is behind this product",
      "loading": "Loading the product’s figures…",
      "allWarehouses": "All warehouses",
      "asOf": "as of {{date}}",
      "status": {
        "OK": "In stock",
        "LOW": "Low",
        "OUT": "Out of stock",
        "NEGATIVE": "Below zero",
        "RUNNING_OUT": "Running out"
      },
      "onHand": "On hand",
      "onOrder": "On order",
      "reorderLevel": "Reorder level",
      "noReorderLevel": "Not set",
      "usagePerDay": "Used per day",
      "daysOfCover": "Stock lasts",
      "days_one": "{{n}} day",
      "days_other": "{{n}} days",
      "lessThanDay": "Less than a day",
      "noCover": "No recent usage",
      "averageCost": "Average cost",
      "value": "Value at cost",
      "usageNote_one": "{{quantity}} used in the last day ({{to}}).",
      "usageNote_other": "{{quantity}} used in the last {{n}} days ({{from}} – {{to}}).",
      "showDetails": "Show details",
      "hideDetails": "Hide details",
      "byWarehouse": "By warehouse",
      "allOfWarehouses": "Show all {{n}} warehouses",
      "fewerWarehouses": "Show fewer",
      "movements_one": "Movements in the last day",
      "movements_other": "Movements in the last {{n}} days",
      "noMovements_one": "Nothing moved this product in the last day.",
      "noMovements_other": "Nothing moved this product in the last {{n}} days.",
      "reason": "Reason",
      "count": "Movements",
      "in": "In",
      "out": "Out",
      "lastReceived": "Last received",
      "lastIssued": "Last issued",
      "lastBought": "Last bought",
      "lastCost": "Unit cost then",
      "suggestion": "The reorder rule suggests",
      "suggestedLevel": "Reorder level",
      "suggestedOrder": "Order now",
      "nothingToOrder": "Nothing to order now",
      "levelNote_one": "The level covers a day of usage.",
      "levelNote_other": "The level covers {{n}} days of usage.",
      "orderNote_one": "The order brings what is on hand and on order up to the reorder level plus a day of usage.",
      "orderNote_other": "The order brings what is on hand and on order up to the reorder level plus {{n}} days of usage.",
      "noSuggestion_one": "Nothing: this product was not sold or issued in the last day.",
      "noSuggestion_other": "Nothing: this product was not sold or issued in the last {{n}} days.",
      "setLevel": "Set reorder level to {{level}}",
      "setLevelConfirm": "Set the reorder level to {{level}}? It is {{current}} now.",
      "setLevelConfirmUnset": "Set the reorder level to {{level}}? None is set now.",
      "setLevelDo": "Set reorder level",
      "setLevelDone": "Reorder level set to {{level}}",
      "ask": "Ask the assistant to explain",
      "askHint": "The figures above come from the stock records, without the assistant. The assistant adds words, and nothing changes until you confirm.",
      "asked": "Asked below. The figures above come from the stock records, without the assistant.",
      "blocked": {
        "paused": "Confirm or discard the proposals waiting below first.",
        "none_left": "You have no questions left today."
      }
    },
    "asksAtOnce": "Asks the assistant right away"
  },
  "service": {
    "menu": "Assistant",
    "title": {
      "ask": "Service assistant"
    },
    "subject": "Service sites",
    "disclaimer": "Uses the sites, places and equipment you are allowed to see, never occupants, addresses or phones. Sent to OpenAI with your company’s key. Nothing is added until you confirm.",
    "empty": {
      "ask": "Ask about the sites, or say what to set up: floors and apartments to add, a villa to copy, equipment for each room. Each change comes as a card for you to confirm."
    },
    "suggest": {
      "floors": "Add floors 1 to 10, each with apartments 01 to 04",
      "copy": "Villa 1 is set up: make villas 2 to 10 the same",
      "outOfOrder": "Which equipment is out of order?"
    },
    "fill": "Fill from a list or a document…",
    "fillHint": "Reads an equipment list into the import preview"
  },
  "company": {
    "button": "Assistant",
    "buttonHint": "Ask the assistant about this page or anything in the company",
    "conversations": "Your other conversations",
    "noConversations": "No other conversations yet.",
    "title": "Assistant",
    "disclaimer": "Uses the records you are allowed to see (sales, purchases, customers, suppliers, expenses, products, the stock, the books, service sites) and the page you ask on. Sent to OpenAI with your company’s key. Nothing changes until you confirm.",
    "empty": "Ask about what is on this page, or look up invoices, customers, purchases, the stock or the books, or ask to open a page. Each change comes as a card for you to confirm.",
    "suggest": {
      "page": "What should I know about this page?",
      "runningOut": "What is running out?",
      "owes": "Who owes us the most?"
    }
  }
}
